import React, { Component, Fragment } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import { Dialog, Transition } from '@headlessui/react';
import Toast from '../controls/BaseToast'
import { ProductOptionCategory } from '../infrastructure/AppConstants';
import { BaseCombobox } from '../controls/BaseCombobox';
import { CheckIcon, BanIcon } from '@heroicons/react/solid'

export default class LineParameterConfigurationViewDialog extends Component {
    constructor(props) {
        super(props);
        const optionCategories = [
            { value: ProductOptionCategory.Attachment, text: "Attachment" },
            { value: ProductOptionCategory.AntiEarwaxDevice, text: "AntiEarwaxDevice" },
            { value: ProductOptionCategory.Vent, text: "Vent" },
            { value: ProductOptionCategory.OnlyForRICSeries, text: "OnlyForRICSeries" },
            { value: ProductOptionCategory.EnclosureColor, text: "EnclosureColor" }];
        this.state = {
            isOpen: false, lines: [], optionCategories: optionCategories,
            optionSelectValue: -1, options: [], isSubmitting: false, currentOptions:[]
        };
    }
    componentDidMount() {
        this.props.onRef(this);
    }
    onChange = (e,id) => {
        const target = e.target;
        const value = target.value;
        const updatedItems = this.state.options.map(item =>
            item.id === id ? { ...item, order: value } : item
        );
        this.setState({ options: updatedItems });
    }
    openDialog = () => {
        this.setState({ isOpen: true });
    };

    closeDialog = () => {
        this.setState({ isOpen: false });
    };
    onClose = () => {
        this.closeDialog();
    }
    updateLines = (lines) => {
       // console.log(lines);
        this.setState({ lines: lines, options: [] });
       
    }
    getLinesLinkProductOptions = async (lineId, enclosureTypeId,category) => {
        if (category == -1) { return; }

        const token = await authService.getAccessToken();
        const response = await fetch('ProductOption/GetLinesLinkProductOptions?lineId=' + lineId + "&enclosureTypeId=" + enclosureTypeId + "&productOptionCategory=" + category, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                const dataMap = new Map(data.map(item => [item.productOptionId, item]));
                const updateOptions = this.state.options.map(x => {
                    const matchedItem = dataMap.get(x.id);
                    if (matchedItem) {
                        return { ...x, checked: true, order: matchedItem.order };
                    }
                    return x; 
                });

                this.setState({ options: updateOptions });
            }
        }
        else {
            console.error('response.status:' + response.status)
        }
    }

    handleValueSeleted = async (e) => {
        this.setState({ optionSelectValue: e.target.value });
        const optionCategory = e.target.value;
        const productId = this.state.lines[0].productId;
        if (optionCategory == -1) {
            this.setState({options:[]});
            return;
        }
        const token = await authService.getAccessToken();
        const response = await fetch('ProductOption/GetProductOptions?optionCategory=' + optionCategory + "&productId=" + productId, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        const data = await response.json();
        const options = data.map(item => ({ ...item, checked: false }));
        this.setState({ options: options });
        if (this.state.lines.length == 1) {
            console.log(this.state.lines[0]);
            this.getLinesLinkProductOptions(this.state.lines[0].line.id, this.state.lines[0].enclosureType.id ,this.state.optionSelectValue)
        }
    }
    handleProductCheck =(e)=> {
        let target = e.target;
        let id = target.id;
        let items = this.state.options;
        for (let i = 0; i < items.length; i++) {
            if (id === items[i].id) {
                items[i].checked = !items[i].checked;
                break;
            }
        }
        this.setState({ options: items });
    }
    handleOnSubmit = async (e) => {
        this.setState({ isSubmitting:true });
        e.preventDefault();
        //console.log(this.state.options.filter(x => x.checked));
        const lineIdsEnclosureTypeIds = [... new Set(this.state.lines.map(item => {
            return {
                LineId: item.line.id,
                EnclosureTypeId: item.enclosureType.id
            }
        }))];
        const options = this.state.options.filter(x => x.checked)
        const optionCategory = this.state.optionSelectValue;
        const token = await authService.getAccessToken();
        const response = await fetch('ProductOption/CreateLinesLinkProductOptions', {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify({
                'lineIdsEnclosureTypeIds': lineIdsEnclosureTypeIds,
                'productOptionModels': options,
                'productOptionCategory': parseInt(optionCategory),
            })
        })
        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    Toast.success(data.message);
                }
                else {
                    Toast.warn(data.message);

                }
            }
        }
        else {
            console.error('response.status:' + response.status)
        }
        this.setState({ isSubmitting: false });
    }

    render() {
        const open = this.state.isOpen;
        return (
            <Transition.Root show={open} as={Fragment}>
                <Dialog
                    as="div"
                    static
                    className="fixed z-10 inset-0 overflow-y-auto"
                    open={open}
                    onClose={() => { }} //禁用外部点击关闭窗口
                >
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <form onSubmit={this.handleOnSubmit} style={{ width: '100vw' }}>
                                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-1/2">
                                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 border-b border-gray-200">
                                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                            <Dialog.Title as="h3" className="text-lg leading-6 font-semibold text-gray-900"><FormattedMessage id="ParameterConfiguration" /></Dialog.Title>
                                        </div>
                                    </div>
                                    <div className="px-14 pt-6 pb-10 space-y-3" style={{minHeight: "24rem"}}>
                                        <div className="flex items-center">
                                            <label className="whitespace-nowrap mr-2 text-sm font-medium text-gray-700"><FormattedMessage id="ProductOptionCategory" /></label>
                                            <BaseCombobox onChangeCapture={this.handleValueSeleted}>
                                                <FormattedMessage id="PickOne" >
                                                    {text => <option value="-1">{text}</option>}
                                                </FormattedMessage>
                                                {this.state.optionCategories.map(o =>
                                                    <FormattedMessage key={o.value} id={o.text}>
                                                        {displayText => <option key={o.value} value={o.value}>{displayText}</option>}
                                                    </FormattedMessage>)}
                                            </BaseCombobox>
                                        </div>
                                        <table className='w-full'>
                                            <thead>
                                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                                                    <th><FormattedMessage id="Name" /></th>
                                                    <th><FormattedMessage id="Code" /></th>
                                                    <th><FormattedMessage id="Index" /></th>
                                                    <th><FormattedMessage id="Actions" /></th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                                                {this.state.options.map(a =>
                                                    <tr key={a.id} className="bg-gra-50 hover:bg-gray-100 text-gray-700 dark:text-gray-400 text-xs">
                                                        <td><p className="font-semibold">{a.name}</p></td>
                                                        <td>{a.code}</td>
                                                        <td>
                                                            <input type="number" value={a.order} onChange={(e) => this.onChange(e, a.id)} className="focus:ring-indigo-500 focus:border-indigo-500 shadow-sm sm:text-sm border-gray-300 rounded-md w-24 h-full" />
                                                        </td>
                                                        <td className="whitespace-nowrap text-sm font-medium">
                                                            <div onClick={this.handleProductCheck} id={a.id} key={a.id}>
                                                                <span className="pointer-events-none flex items-center pl-3">
                                                                    {
                                                                        a.checked ? <CheckIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" /> :
                                                                            <BanIcon className="h-5 w-5 text-red-500 group-hover:text-red-400" aria-hidden="true" />}
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                        <button
                                            type="button"
                                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                            onClick={this.onClose}><FormattedMessage id="Cancel" /></button>
                                        <button disabled={this.state.isSubmitting} type="submit"
                                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none sm:ml-3 sm:w-auto sm:text-sm"><FormattedMessage id="Submit" /></button>

                                    </div>
                                </div>
                            </form>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition.Root >
        )
    }
}